import type { Update } from '@ngrx/entity';
import type { Uuid } from '@common/types';
import type { NormalizedSectionEntity, DenormalizedSectionEntity, WidgetCorrelationData } from '@web/types';

import { createActionGroup, props } from '@ngrx/store';

const SectionsActions = createActionGroup({
    source: 'PageStructure/Sections',
    events: {
        init: props<{ sections: NormalizedSectionEntity[] }>(),
        'Add section': props<{ section: NormalizedSectionEntity; index: number }>(),
        'Add many sections': props<{ sections: NormalizedSectionEntity[] }>(),
        'Create section': props<{
            blockId: Uuid;
            index: number;
            widgetCorrelationData?: WidgetCorrelationData;
            skipHistory?: boolean;
        }>(),
        'Create specific section': props<{ blockId: Uuid; index: number; skipHistory?: boolean }>(),
        'Create zero section': props<{ blockId: Uuid; index: number; skipHistory?: boolean }>(),
        'Section created': props<{ section: NormalizedSectionEntity; index: number; skipHistory?: boolean }>(),
        'Copy many sections': props<{ sections: NormalizedSectionEntity[] }>(),
        'Remove section': props<{ section: DenormalizedSectionEntity; index?: number; skipHistory?: boolean }>(),
        'Remove many sections': props<{ sectionsIds: string[] }>(),
        'Update section properties': props<{ update: Update<NormalizedSectionEntity> }>(),
        'Move up': props<{ index: number; blockId: Uuid; skipHistory?: boolean }>(),
        'Move down': props<{ index: number; blockId: Uuid; skipHistory?: boolean }>(),
    },
});

export default SectionsActions;
